// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".billing-trial-header[data-v-764da292]{background-color:var(--layout-bg-color);position:fixed;left:225px;width:calc(100vw - 225px);top:50px;z-index:20}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
